/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box, Grid, InputAdornment, styled, TextField, useTheme,
} from '@material-ui/core';
import React, { useEffect, useState, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import Tooltip from '@material-ui/core/Tooltip';
import { OpenInNew } from '@material-ui/icons';
import { isAfter } from 'date-fns';
import searchIcon from '../../../../assets/img/iconos/ibuhoo/searchIcon.svg';
import CustomTable from '../../../../components/form/Table/Agreements/CustomTable';
import { getAgreementListAction, contractAnnulmentAction } from '../../../../actions/license.action';
import Loading from '../../../../components/crosscutting/Loading';
import IconAdd from '../../../../assets/img/iconos/pancert/IconAdd';
import ObservationsConfirm from '../../../../components/crosscutting/confirmationWindows/ObservationsConfirm';
import WarningIcon from '../../../../components/IconsLibrary/WarningIcon';
import SuccesfullIcon from '../../../../components/IconsLibrary/SuccesfullIcon';
import AlertConfirm from '../../../../components/crosscutting/confirmationWindows/AlertConfirm';

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});

const getBorderColor = (theme) => {
  if (theme?.backOffice?.contracts?.searchBar?.border) {
    return theme?.backOffice?.contracts?.searchBar?.border;
  }
  return '#D5D5D5';
};

const alertStyles = (
  theme, firstImageIcon, minWidth, minHeight, marginTopImage, minWidthButtonAcept,
) => ({
  styleMessage: {
    ...getMulishText(700, '#575756', '18px'),
    paddingBottom: 15,
  },
  dialogStyle: { minWidth, minHeight },
  firstImage: firstImageIcon,
  firstImageStyles: {
    display: 'block',
    margin: 'auto',
    marginTop: marginTopImage,
  },
  styleTitle: {
    fontFamily: 'Mulish, sans-serif',
    fontSize: '20px',
    fontWeight: 700,
    marginTop: '-25px',
  },
  styleButtonCancel: {
    backgroundColor: '#FFFFFF',
    color: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
    border: `1px solid ${theme?.backOffice?.contracts?.btnSteps?.backgroundColor}`,
  },
  styleButtonAcept: {
    minWidth: minWidthButtonAcept,
  },
});

const MySearchBar = styled(TextField)(({ theme }) => ({
  marginLeft: '5px',
  boxShadow: '0px 3px 2px #00000026',
  width: '100%',
  borderRadius: '10px',
  background: 'var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box',
  border: `1px solid ${getBorderColor(theme)}`,
  opacity: 1,
  height: '33px',
}));

const MyBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
});

const ListAgreements = (props) => {
  const {
    listAgreements, getAgreementList, contractAnnulment, setActiveSection, permissions, contractAnnulmentResult
  } = props;
  
  const theme = useTheme();
  const [dataList, setDataList] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [totalDataRecords, setTotalDataRecords] = useState();
  const [skipCount, setSkipCount] = useState({ skip: 0, take: 100 });
  const [loadedDataCount, setLoadedDataCount] = useState({ page: 0, currentTotalData: 0 });
  const [dataSearching, setDataSearching] = useState('');
  const [isLoading, setisLoading] = useState(false);
  const [openAlertConfirmTicket, setOpenAlertConfirmTicket] = useState(false);
  const [contractIdRow, setContractIdRow] = useState(0);
  const [ticketAction, setTicketAction] = useState(null);
  const [messagesAlertView, setMessagesAlertView] = useState({});
  const [messagesAlertViewOpen, setMessagesAlertViewOpen] = useState(false);
  const dialogColorIcon = theme?.miplan?.buttonCard?.backgroundColor;
  const succesfullColor = theme?.miplan?.hoverButtonCard?.backgroundColor;

  const {
    errors, control, getValues, setError,
  } = useForm({
    mode: 'onChange',
  });

  /**
   * If the user does not have edit or annulment permissions,
   * the view details icon takes the last position.
   */
  const columns = useMemo(() => {
    const baseColumns = [
      {
        id: 'serviceName',
        label: 'Producto',
        width: 260,
        position: 1,
        isSortable: true,
        sortPropertyName: 'serviceName',
      },
      {
        id: 'contractNumber',
        label: 'No. de oportunidad',
        width: 223,
        position: 2,
        isSortable: true,
        sortPropertyName: 'contractNumber',
      },
      {
        id: 'contractStartDate',
        label: 'Fecha inicio',
        width: 160,
        position: 3,
        isSortable: false,
        sortPropertyName: 'contractStartDate',
      },
      {
        id: 'contractEndDate',
        label: 'Fecha fin',
        width: 140,
        position: 4,
        isSortable: false,
        sortPropertyName: 'contractEndDate',
      },
      {
        id: 'supervisor',
        label: 'Supervisor',
        width: 165,
        position: 5,
        isSortable: false,
        sortPropertyName: 'supervisor',
      },
      {
        id: '',
        label: '',
        width: 100,
        position: 6,
        isSortable: false,
        sortPropertyName: '',
      },
      {
        id: 'agreementDetails',
        label: '',
        width: 6,
        position: 7,
        isSortable: false,
        sortPropertyName: 'agreementDetails',
      },
    ];
    if (permissions?.includes('modifyContract')) {
      baseColumns.push(
        {
          id: 'detailsEdit',
          label: '',
          width: 6,
          position: 8,
          isSortable: false,
          sortPropertyName: 'detailsEdit',
        },
      );
    }
    if (permissions?.includes('annulmentContract')) {
      baseColumns.push(
        {
          id: 'annulment',
          label: '',
          width: 6,
          position: 9,
          isSortable: false,
          sortPropertyName: 'annulment',
        },
      );
    }
    return baseColumns;
  }, [permissions]);

  /**
   * Check if privileges and dates of contract can modify any contract
   * @param {*} contractEndDate end of contract
   * @returns true if role and contract end date is before than current date
   */
  const canEditContract = (contractEndDate) => {
    const formatContractEndDate = new Date(contractEndDate);
    if (permissions?.includes('modifyContract')) {
      if (permissions?.includes('modifyContractExtension') || !isAfter(new Date(), formatContractEndDate)) {
        return true;
      }
    }
    return false;
  };

  const canAnnulmentContract = (status, contractEndDate) => {
    const formatContractEndDate = new Date(contractEndDate);
    
    if (permissions?.includes('annulmentContract') && status !== 'ANULACION_CONTRATO' && !isAfter(new Date(), formatContractEndDate)) {
      return true;
    }

    return false;
  };

  const getAgreementDetailIcons = (uniqueId) => (
    <MyBox>
      <Tooltip title="Ver detalle">
        <OpenInNew
          style={{
            cursor: 'pointer',
            color: theme.backOffice.configurations.editIcon.color,
          }}
          onClick={() => {
            setActiveSection({ id: uniqueId, section: 'detail' });
          }}
        />
      </Tooltip>
    </MyBox>
  );

  const getDetailEditIcons = (uniqueId, contractEndDate, purchaseSourceCode) => {
    if (purchaseSourceCode === 'MARKETPLACE') {
      return null;
    }

    return (
      <MyBox>
        <Tooltip title="Editar">
          <EditIcon
            style={{
              cursor: canEditContract(contractEndDate) ? 'pointer' : 'not-allowed',
              color: canEditContract(contractEndDate)
                ? theme.backOffice.configurations.editIcon.color
                : '#AEACAD',
            }}
            onClick={() => {
              if (canEditContract(contractEndDate)) {
                setActiveSection({ id: uniqueId, section: 'edit' });
              }
            }}
          />
        </Tooltip>
      </MyBox>
    );
  };

  const getDetailAnnulmentIcons = (uniqueId, state, contractEndDate, purchaseSourceCode) => {
    if (purchaseSourceCode === 'MARKETPLACE') {
      return null;
    }
    if (!canAnnulmentContract(state, contractEndDate)) {
      return null;
    }

    return (
      <MyBox>
        <Tooltip title="Anular">
          <ClearIcon
            style={{
              cursor: canAnnulmentContract(state, contractEndDate) ? 'pointer' : 'not-allowed',
              color: canAnnulmentContract(state, contractEndDate)
                ? theme.backOffice.configurations.editIcon.color
                : '#AEACAD',
            }}
            onClick={() => {
              if (canAnnulmentContract(state, contractEndDate)) {
                setOpenAlertConfirmTicket(true);
                setContractIdRow(uniqueId);
                setTicketAction('annulmentContrat');
              }
            }}
          />
        </Tooltip>
      </MyBox>
    );
  };

  const handleCancelModifyTicket = () => {
    setOpenAlertConfirmTicket(false);
  };

  const handleConfirmTicket = () => {
    const ticket = getValues('ticketService');
    const observations = getValues('observations');

    if (!ticket) {
      setError('ticketService', {
        type: 'required',
        message: 'Campo obligatorio',
      });
    }
    if (!observations) {
      setError('observations', { 
        type: 'required',
        message: 'Campo obligatorio',
      });
    }
    if (!ticket || !observations) {
      return;
    }
    
    const completeData = {     
      ticketService: ticket,
      observations,
    };    
    
    commpleteActionTicket(completeData)
    setOpenAlertConfirmTicket(false);
    
  };

  const commpleteActionTicket = (dataTicket) => {  
    switch (ticketAction) {
      case 'annulmentContrat':
        const contractRow = listAgreements.contractList.find(x => x.contractId === contractIdRow)

        const annulmentContractRequest = {
          ...dataTicket,
          contractNumber: contractRow.contractNumber,
          serviceName: contractRow.serviceName,
        };

        contractAnnulment(annulmentContractRequest);
        break;
    
      default:
        break;
    }
  }

  const OwnWarningIcon = useMemo(() => (
    <WarningIcon color={dialogColorIcon} />
  ), [dialogColorIcon]);

  const OwnSuccesfullIcon = useMemo(() => (
    <SuccesfullIcon color={succesfullColor} />
  ), [succesfullColor]);

  useEffect(() => {
    if (dataSearching && loadedDataCount.page !== 0) {
      setisLoading(true);
      const upperData = dataSearching.toLocaleUpperCase();
      getAgreementList(upperData, '', skipCount.skip, skipCount.take);
    } else if (loadedDataCount.page !== 0) {
      setisLoading(true);
      getAgreementList('', '', skipCount.skip, skipCount.take);// Skip , take
    }
  }, [skipCount]);

  useEffect(() => {
    getAgreementList('', '', skipCount.skip, skipCount.take);
  }, []);

  useEffect(() => {
    if (listAgreements && Array.isArray(listAgreements.contractList)) {
      const newList = listAgreements.contractList
        .map((agreement) => ({
          serviceName: agreement.serviceDescription,
          contractNumber: agreement.contractNumber,
          contractStartDate: agreement.contractStartDate ? new Date(agreement.contractStartDate).toLocaleDateString('es-ES') : '',
          contractEndDate: agreement.contractEndDate ? new Date(agreement.contractEndDate).toLocaleDateString('es-ES') : '',
          supervisor: (agreement.supervisorDocumentType && agreement.supervisorDocumentNumber)
            ? `${agreement.supervisorDocumentType} ${agreement.supervisorDocumentNumber}`
            : 'Sin supervisor',
          agreementDetails: getAgreementDetailIcons(agreement.contractId),
          detailsEdit: getDetailEditIcons(agreement.contractId, agreement.contractEndDate, agreement.purchaseSourceCode),
          annulment: getDetailAnnulmentIcons(agreement.contractId, agreement.stateCode, agreement.contractEndDate, agreement.purchaseSourceCode),
          state: 0,
          contractId: agreement.contractId,
          supervisorFullName: agreement.supervisorFullName,
        }));
      setTotalDataRecords(listAgreements.totalRecords);
      setDataFilter([]);
      if (loadedDataCount.page === 0) {
        setDataList(newList);
      } else {
        setDataList((prev) => {
          const nuevos = newList.filter(
            (nuevo) => !prev.some((existente) => existente.contractId === nuevo.contractId),
          );
          return [...prev, ...nuevos];
        });
      }
    }
    setisLoading(false);
  }, [listAgreements]);

  
  useEffect(() => {
    let timer;
    let message;
    let messageError;
    let isOnlyMessage = false;
    let textButtonAcept;
    let isSuccess = false;

    if (contractAnnulmentResult) {
      if (contractAnnulmentResult.success === true) {
        message = '¡Convenio anulado!';
        messageError = '';
        isOnlyMessage = true;
        isSuccess = true;

        timer = setTimeout(() => {
          setMessagesAlertViewOpen(false);
          window.location.href = '/admin/agreements';
        }, 4000);
      }
      else {
        message = 'No fue posible anular el convenio';
        messageError = 'No pudimos procesar la anulación de su convenio. Intente nuevamente. Si el problema continúa, comuníquese con soporte.';
        isOnlyMessage = false;
        textButtonAcept = 'Entendido';
        isSuccess = false;
      }
      
      setisLoading(false);
      setMessagesAlertViewOpen(true);
      setMessagesAlertView({
        tituloModal: message,
        messageAlert: alertStyles(theme, isSuccess ? OwnSuccesfullIcon : OwnWarningIcon, '508px', '284px', 65),
        mensajeModal: messageError,
        isOnlyMessage: isOnlyMessage,
        showClose: false,
        textButtonAcept: textButtonAcept =! null ? textButtonAcept : null,
        handleAccept: () => { 
          setMessagesAlertViewOpen(false); 
          window.location.href = '/admin/agreements'; 
        },
      });
      
    } 
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [contractAnnulmentResult]);

  const handleSearch = (search) => {
    setDataSearching(search);
    if (!search.trim()) {
      setDataFilter(dataList);
      return;
    }
    const normalize = (str) => str?.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const searchLower = normalize(search);
    const filter = dataList.filter((item) => normalize(item.serviceName).includes(searchLower)
      || normalize(item.contractNumber).includes(searchLower));
    setDataFilter(filter);
  };

  useEffect(() => {
    if (loadedDataCount?.currentTotalData > (skipCount.skip + skipCount.take)) {
      setSkipCount((prev) => ({
        skip: (prev.skip + prev.take),
        take: 100,
      }));
    } else if (loadedDataCount.page === 0) {
      setSkipCount({ skip: 0, take: 100 });
    }
  }, [loadedDataCount]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setisLoading(true);
      if (dataSearching) {
        const upperData = dataSearching.toLocaleUpperCase();
        getAgreementList(upperData, '', 0, 100);
      } else {
        getAgreementList('', '', 0, 100);
      }
    }
  };

  return (
    <Grid container>
      { isLoading && <Loading />}
      <Grid item xs={7}>
        <MySearchBar
          value={dataSearching}
          onChange={(e) => handleSearch(e.target.value)}
          onKeyDown={handleKeyDown}
          InputProps={{
            style: { fontFamily: 'Mulish, sans-serif' },
            startAdornment: (
              <InputAdornment position="start">
                <img
                  src={searchIcon}
                  alt="searchIcon"
                  style={{ paddingLeft: '10px' }}
                />
              </InputAdornment>
            ),
            disableUnderline: true,
            placeholder: 'Buscar',
          }}
        />
      </Grid>
      <Grid item xs={5} container justifyContent="flex-end">
        {permissions?.includes('btnCreateContract') && (
          <Tooltip title="Crear convenio">
            <span style={{ display: 'inline-block' }}>
              <IconAdd
                onClick={() => {
                  setActiveSection({ id: 0, section: 'agregate' });
                }}
                style={{
                  cursor: 'pointer',
                  fontSize: '32px',
                }}
                color={theme.palette.secondary.main}
              />
            </span>
          </Tooltip>
        )}
      </Grid>
      <Grid item xs={12}>
        <CustomTable
          data={(dataFilter?.length > 0) ? dataFilter : dataList}
          columns={columns}
          styleTableContainer={{
            marginTop: '15px',
            width: 'auto',
          }}
          styleTableHead={{ backgroundColor: theme.home.cart.tableHead.backgroundColor }}
          totalDataSaved={totalDataRecords}
          setLoadedDataCount={setLoadedDataCount}
          currentPage={loadedDataCount.page}
          customPagination={[10, 25, 50]}
          isAgreementTable
        />
      </Grid>
      <ObservationsConfirm
        isOpen={openAlertConfirmTicket}
        textTitle="Ingresa el Número del ticket"
        firstImage={OwnWarningIcon}
        objControl={{
          control,
          errors,
        }}
        objInputs={{
          label1: 'Número de ticket',
          name1: 'ticketService',
          label2: 'Observaciones',
          name2: 'observations',
        }}
        objButtons={{
          textCancel: 'Cancelar',
          textAccept: 'Guardar',
          handleCancel: () => handleCancelModifyTicket(),
          handleAccept: () => handleConfirmTicket(),
          styleButtonAccept: {
            width: '116px',
            backgroundColor: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
            color: '#FFFF',
          },
          styleButtonCancel: {
            backgroundColor: '#FFFFFF',
            color: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
            border: `1px solid ${theme?.backOffice?.contracts?.btnSteps?.backgroundColor}`,
            width: '116px',
          },
        }}
      />
      <AlertConfirm
        isOpen={messagesAlertViewOpen}
        tituloModal={messagesAlertView?.tituloModal}
        textButtonAcept={messagesAlertView?.textButtonAcept}
        mensajeModal={messagesAlertView?.mensajeModal}
        handleAccept={messagesAlertView?.handleAccept}
        onCancel={messagesAlertView?.onCancel}
        onClose={messagesAlertView?.onClose}
        messageAlert={messagesAlertView?.messageAlert}
        showClose={messagesAlertView?.showClose}
        isOnlyMessage={messagesAlertView?.isOnlyMessage}
      />
    </Grid>
  );
};

const mapStateToProps = (props) => ({
  listAgreements: props.license.agreementsList,
  contractAnnulmentResult: props.license.contractAnnulmentResult,
});

const mapDispatchProps = {
  getAgreementList: getAgreementListAction,
  contractAnnulment: contractAnnulmentAction,
};

export default connect(mapStateToProps, mapDispatchProps)(ListAgreements);
